import React from "react";
import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaArrowRight,
    FaPaperPlane,
    FaChevronRight,
    FaClock,
    FaGraduationCap,
    FaUserTie,
    FaUsers,
    FaLightbulb,
    FaChartLine,
    FaBriefcase,
    FaComments,
    FaCompass,
    FaBullseye,
    FaBookOpen,
} from "react-icons/fa";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="cayep-footer">
            <style>{`
                .cayep-footer {
                    position: relative;
                    width: 100%;
                    overflow: hidden;
                    background:
                        linear-gradient(
                            180deg,
                            #ffffff 0%,
                            #f0edea 55%,
                            #e8e6e1 100%
                        );
                    color: #0a0f12;
                    font-family: "Poppins", "Inter", sans-serif;
                    border-top: 1px solid rgba(6, 42, 75, 0.10);
                }

                .cayep-footer::before {
                    content: "";
                    position: absolute;
                    width: 420px;
                    height: 420px;
                    border-radius: 50%;
                    background: rgba(246, 201, 68, 0.11);
                    top: -220px;
                    left: -180px;
                    pointer-events: none;
                }

                .cayep-footer::after {
                    content: "";
                    position: absolute;
                    width: 460px;
                    height: 460px;
                    border-radius: 50%;
                    background: rgba(79, 174, 34, 0.07);
                    bottom: -250px;
                    right: -190px;
                    pointer-events: none;
                }

                .cayep-footer-accent {
                    position: relative;
                    z-index: 2;
                    width: 100%;
                    height: 6px;
                    display: flex;
                    overflow: hidden;
                }

                .cayep-footer-accent span {
                    flex: 1;
                }

                .cayep-footer-accent span:nth-child(1) {
                    background: #062a4b;
                }

                .cayep-footer-accent span:nth-child(2) {
                    background: #f6c944;
                }

                .cayep-footer-accent span:nth-child(3) {
                    background: #4fae22;
                }

                .cayep-footer-accent span:nth-child(4) {
                    background: #0f6dab;
                }

                .cayep-footer-main {
                    position: relative;
                    z-index: 2;
                    width: min(1450px, 92%);
                    margin: auto;
                    padding: 78px 0 55px;
                    display: grid;
                    grid-template-columns:
                        minmax(280px, 1.3fr)
                        minmax(170px, 0.75fr)
                        minmax(190px, 0.85fr)
                        minmax(280px, 1fr);
                    gap: 55px;
                }

                .cayep-footer-brand-section {
                    min-width: 0;
                }

                .cayep-footer-brand {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    margin-bottom: 22px;
                }

                .cayep-footer-brand-icon {
                    width: 60px;
                    height: 60px;
                    min-width: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 17px;
                    color: #062a4b;
                    font-size: 26px;
                    background:
                        linear-gradient(
                            135deg,
                            #f6c944,
                            #efa81c
                        );
                    box-shadow:
                        0 14px 30px rgba(239, 168, 28, 0.22);
                    position: relative;
                }

                .cayep-footer-brand-icon::after {
                    content: "";
                    position: absolute;
                    inset: -5px;
                    border: 1px solid rgba(246, 201, 68, 0.35);
                    border-radius: 21px;
                }

                .cayep-footer-brand-text h2 {
                    margin: 0;
                    font-size: 25px;
                    line-height: 1.1;
                    font-weight: 850;
                    letter-spacing: -0.7px;
                    color: #062a4b;
                }

                .cayep-footer-brand-text h2 span {
                    color: #efa81c;
                }

                .cayep-footer-brand-text > span {
                    display: block;
                    margin-top: 7px;
                    color: #5f6622;
                    font-size: 10px;
                    font-weight: 800;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                }

                .cayep-footer-description {
                    max-width: 480px;
                    margin: 0 0 25px;
                    color: #53616d;
                    font-size: 14px;
                    line-height: 1.9;
                }

                .cayep-footer-learning-tags {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 9px;
                    margin-bottom: 28px;
                }

                .cayep-footer-learning-tag {
                    display: inline-flex;
                    align-items: center;
                    gap: 7px;
                    padding: 8px 11px;
                    border-radius: 9px;
                    background: rgba(255, 255, 255, 0.85);
                    border: 1px solid rgba(6, 42, 75, 0.10);
                    color: #44525d;
                    font-size: 11px;
                    font-weight: 650;
                    transition:
                        transform 0.25s ease,
                        border-color 0.25s ease,
                        color 0.25s ease,
                        box-shadow 0.25s ease;
                }

                .cayep-footer-learning-tag svg {
                    color: #efa81c;
                    font-size: 12px;
                }

                .cayep-footer-learning-tag:hover {
                    transform: translateY(-3px);
                    border-color: rgba(239, 168, 28, 0.40);
                    color: #062a4b;
                    box-shadow:
                        0 9px 22px rgba(6, 42, 75, 0.07);
                }

                .cayep-footer-social-area {
                    margin-top: 22px;
                }

                .cayep-footer-social-area > span {
                    display: block;
                    margin-bottom: 12px;
                    color: #062a4b;
                    font-size: 11px;
                    font-weight: 800;
                    text-transform: uppercase;
                    letter-spacing: 1.2px;
                }

                .cayep-footer-social-links {
                    display: flex;
                    gap: 10px;
                }

                .cayep-footer-social-links a {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 11px;
                    background: #ffffff;
                    border: 1px solid rgba(6, 42, 75, 0.12);
                    color: #52606b;
                    text-decoration: none;
                    transition:
                        transform 0.25s ease,
                        color 0.25s ease,
                        background 0.25s ease,
                        border-color 0.25s ease,
                        box-shadow 0.25s ease;
                }

                .cayep-footer-social-links a:hover {
                    transform: translateY(-4px);
                    color: #062a4b;
                    background: #f6c944;
                    border-color: #f6c944;
                    box-shadow:
                        0 9px 20px rgba(239, 168, 28, 0.18);
                }

                .cayep-footer-column {
                    min-width: 0;
                }

                .cayep-footer-title {
                    display: flex;
                    align-items: center;
                    gap: 11px;
                    margin-bottom: 23px;
                }

                .cayep-footer-title-icon {
                    width: 34px;
                    height: 34px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 9px;
                    color: #062a4b;
                    background: #fff7d6;
                    border: 1px solid rgba(246, 201, 68, 0.45);
                    font-size: 13px;
                }

                .cayep-footer-title h3 {
                    margin: 0;
                    font-size: 16px;
                    font-weight: 850;
                    color: #062a4b;
                }

                .cayep-footer-column ul {
                    padding: 0;
                    margin: 0;
                    list-style: none;
                }

                .cayep-footer-column li {
                    margin-bottom: 13px;
                }

                .cayep-footer-column li a {
                    display: inline-flex;
                    align-items: center;
                    gap: 9px;
                    color: #5d6b76;
                    text-decoration: none;
                    font-size: 13px;
                    transition:
                        color 0.2s ease,
                        transform 0.2s ease;
                }

                .cayep-footer-column li a svg {
                    color: #efa81c;
                    font-size: 9px;
                    transition: transform 0.2s ease;
                }

                .cayep-footer-column li a:hover {
                    color: #062a4b;
                    transform: translateX(4px);
                }

                .cayep-footer-column li a:hover svg {
                    transform: translateX(3px);
                    color: #4fae22;
                }

                .cayep-footer-contact-section {
                    min-width: 0;
                }

                .cayep-footer-contact-grid {
                    display: flex;
                    flex-direction: column;
                    gap: 14px;
                }

                .cayep-footer-contact-card {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    padding: 13px;
                    border-radius: 13px;
                    background: rgba(255, 255, 255, 0.82);
                    border: 1px solid rgba(6, 42, 75, 0.10);
                    transition:
                        transform 0.25s ease,
                        box-shadow 0.25s ease,
                        border-color 0.25s ease;
                }

                .cayep-footer-contact-card:hover {
                    transform: translateY(-3px);
                    border-color: rgba(79, 174, 34, 0.30);
                    box-shadow:
                        0 10px 25px rgba(6, 42, 75, 0.07);
                }

                .cayep-footer-contact-icon {
                    width: 36px;
                    height: 36px;
                    min-width: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 9px;
                    background: #edf6e9;
                    color: #4fae22;
                    font-size: 13px;
                }

                .cayep-footer-contact-card span {
                    display: block;
                    margin-bottom: 3px;
                    color: #062a4b;
                    font-size: 10px;
                    font-weight: 800;
                    text-transform: uppercase;
                    letter-spacing: 0.8px;
                }

                .cayep-footer-contact-card p {
                    margin: 0;
                    color: #63717c;
                    font-size: 12px;
                    line-height: 1.6;
                    word-break: break-word;
                }

                .cayep-footer-connect {
                    position: relative;
                    z-index: 3;
                    width: min(1350px, 90%);
                    margin: 0 auto;
                    padding: 27px 30px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 30px;
                    border-radius: 20px;
                    background:
                        linear-gradient(
                            135deg,
                            #062a4b 0%,
                            #063a6b 62%,
                            #0f6dab 100%
                        );
                    border: 1px solid rgba(246, 201, 68, 0.25);
                    box-shadow:
                        0 18px 50px rgba(6, 42, 75, 0.18);
                }

                .cayep-footer-connect-content {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }

                .cayep-footer-connect-icon {
                    width: 49px;
                    height: 49px;
                    min-width: 49px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 14px;
                    color: #062a4b;
                    background: #f6c944;
                    box-shadow:
                        0 10px 25px rgba(0, 0, 0, 0.16);
                }

                .cayep-footer-connect-content h4 {
                    margin: 0 0 4px;
                    color: #ffffff;
                    font-size: 15px;
                    font-weight: 850;
                }

                .cayep-footer-connect-content p {
                    margin: 0;
                    color: rgba(255, 255, 255, 0.72);
                    font-size: 12px;
                    line-height: 1.5;
                }

                .cayep-footer-newsletter {
                    display: flex;
                    width: min(100%, 480px);
                    height: 48px;
                    padding: 4px;
                    border-radius: 12px;
                    background: #ffffff;
                    border: 1px solid rgba(255, 255, 255, 0.35);
                }

                .cayep-footer-newsletter input {
                    flex: 1;
                    min-width: 0;
                    border: none;
                    outline: none;
                    padding: 0 13px;
                    background: transparent;
                    color: #0a0f12;
                    font-size: 13px;
                    font-family: inherit;
                }

                .cayep-footer-newsletter input::placeholder {
                    color: #8b98a2;
                }

                .cayep-footer-newsletter button {
                    border: none;
                    outline: none;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 0 18px;
                    border-radius: 9px;
                    background: #f6c944;
                    color: #062a4b;
                    font-family: inherit;
                    font-size: 12px;
                    font-weight: 800;
                    cursor: pointer;
                    transition:
                        background 0.25s ease,
                        transform 0.25s ease;
                }

                .cayep-footer-newsletter button:hover {
                    background: #efa81c;
                    transform: translateY(-1px);
                }

                .cayep-footer-motto {
                    position: relative;
                    z-index: 2;
                    width: min(1000px, 88%);
                    margin: 50px auto 30px;
                    padding: 0 25px;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                }

                .cayep-footer-motto span {
                    flex: 1;
                    height: 1px;
                    background:
                        linear-gradient(
                            90deg,
                            transparent,
                            rgba(6, 42, 75, 0.20)
                        );
                }

                .cayep-footer-motto span:last-child {
                    background:
                        linear-gradient(
                            90deg,
                            rgba(6, 42, 75, 0.20),
                            transparent
                        );
                }

                .cayep-footer-motto p {
                    margin: 0;
                    text-align: center;
                    color: #5f6622;
                    font-size: 12px;
                    font-weight: 750;
                    letter-spacing: 0.8px;
                    white-space: nowrap;
                }

                .cayep-footer-bottom {
                    position: relative;
                    z-index: 2;
                    background: #062a4b;
                    color: #ffffff;
                }

                .cayep-footer-bottom-inner {
                    width: min(1450px, 92%);
                    margin: auto;
                    padding: 23px 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                }

                .cayep-footer-bottom p {
                    margin: 0;
                    color: rgba(255, 255, 255, 0.65);
                    font-size: 11px;
                    line-height: 1.6;
                }

                .cayep-footer-bottom p strong {
                    color: #f6c944;
                }

                .cayep-footer-bottom-links {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex-wrap: wrap;
                }

                .cayep-footer-bottom-links a {
                    color: rgba(255, 255, 255, 0.72);
                    text-decoration: none;
                    font-size: 11px;
                    transition: color 0.2s ease;
                }

                .cayep-footer-bottom-links a:hover {
                    color: #f6c944;
                }

                .cayep-footer-bottom-links span {
                    color: rgba(255, 255, 255, 0.25);
                    font-size: 10px;
                }

                @media (max-width: 1200px) {
                    .cayep-footer-main {
                        grid-template-columns:
                            1.2fr
                            0.8fr
                            0.8fr;
                    }

                    .cayep-footer-contact-section {
                        grid-column: 1 / -1;
                    }

                    .cayep-footer-contact-grid {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                    }
                }

                @media (max-width: 900px) {
                    .cayep-footer-main {
                        padding: 60px 0 45px;
                        grid-template-columns: 1fr 1fr;
                        gap: 45px 35px;
                    }

                    .cayep-footer-brand-section {
                        grid-column: 1 / -1;
                    }

                    .cayep-footer-connect {
                        width: 90%;
                    }
                }

                @media (max-width: 650px) {
                    .cayep-footer-main {
                        grid-template-columns: 1fr;
                        padding: 50px 0 40px;
                        gap: 35px;
                    }

                    .cayep-footer-brand-section,
                    .cayep-footer-contact-section {
                        grid-column: auto;
                    }

                    .cayep-footer-brand-text h2 {
                        font-size: 21px;
                    }

                    .cayep-footer-description {
                        font-size: 13px;
                    }

                    .cayep-footer-contact-grid {
                        grid-template-columns: 1fr;
                    }

                    .cayep-footer-connect {
                        width: 90%;
                        padding: 22px;
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .cayep-footer-newsletter {
                        width: 100%;
                    }

                    .cayep-footer-motto {
                        margin-top: 40px;
                    }

                    .cayep-footer-motto span {
                        display: none;
                    }

                    .cayep-footer-motto p {
                        width: 100%;
                        white-space: normal;
                        line-height: 1.7;
                    }

                    .cayep-footer-bottom-inner {
                        width: 88%;
                        padding: 22px 0;
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .cayep-footer-bottom-links {
                        gap: 8px;
                    }
                }

                @media (max-width: 420px) {
                    .cayep-footer-brand {
                        align-items: flex-start;
                    }

                    .cayep-footer-brand-icon {
                        width: 50px;
                        height: 50px;
                        min-width: 50px;
                        font-size: 21px;
                    }

                    .cayep-footer-brand-text h2 {
                        font-size: 19px;
                    }

                    .cayep-footer-brand-text > span {
                        font-size: 9px;
                        letter-spacing: 1px;
                    }

                    .cayep-footer-newsletter {
                        height: auto;
                        flex-direction: column;
                        padding: 7px;
                        gap: 7px;
                    }

                    .cayep-footer-newsletter input {
                        height: 42px;
                    }

                    .cayep-footer-newsletter button {
                        height: 42px;
                    }
                }

                @media (prefers-reduced-motion: reduce) {
                    .cayep-footer *,
                    .cayep-footer *::before,
                    .cayep-footer *::after {
                        transition: none !important;
                        animation: none !important;
                    }
                }
            `}</style>

            <div className="cayep-footer-accent">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div className="cayep-footer-main">
                <div className="cayep-footer-brand-section">
                    <div className="cayep-footer-brand">
                        <div className="cayep-footer-brand-icon">
                            <FaGraduationCap />
                        </div>

                        <div className="cayep-footer-brand-text">
                            <h2>
                                <span>CAYEP</span> Leadership Training
                            </h2>

                            <span>
                                Educate • Equipt • Empower 
                            </span>
                        </div>
                    </div>

                    <p className="cayep-footer-description">
                        CAYEP Leadership Training is focused on developing
                        practical leadership, career, entrepreneurship, and
                        professional skills that help learners grow with
                        confidence and purpose.
                    </p>

                    <div className="cayep-footer-learning-tags">
                        <div className="cayep-footer-learning-tag">
                            <FaUserTie />
                            Leadership Development
                        </div>

                        <div className="cayep-footer-learning-tag">
                            <FaChartLine />
                            Career Development
                        </div>

                        <div className="cayep-footer-learning-tag">
                            <FaLightbulb />
                            Entrepreneurship
                        </div>

                        <div className="cayep-footer-learning-tag">
                            <FaBriefcase />
                            Business Management
                        </div>

                        <div className="cayep-footer-learning-tag">
                            <FaUsers />
                            HR Management
                        </div>

                        <div className="cayep-footer-learning-tag">
                            <FaComments />
                            Public Speaking
                        </div>
                    </div>

                    <div className="cayep-footer-social-area">
                        <span>
                            Connect With CAYEP
                        </span>

                        <div className="cayep-footer-social-links">
                            <a
                                href="#"
                                aria-label="Facebook"
                            >
                                <FaFacebookF />
                            </a>

                            <a
                                href="#"
                                aria-label="Instagram"
                            >
                                <FaInstagram />
                            </a>

                            <a
                                href="#"
                                aria-label="LinkedIn"
                            >
                                <FaLinkedinIn />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="cayep-footer-column">
                    <div className="cayep-footer-title">
                        <span className="cayep-footer-title-icon">
                            <FaCompass />
                        </span>

                        <h3>
                            Explore
                        </h3>
                    </div>

                    <ul>
                        <li>
                            <a href="#home">
                                <FaChevronRight />
                                <span>Home</span>
                            </a>
                        </li>

                        <li>
                            <a href="#about">
                                <FaChevronRight />
                                <span>About CAYEP</span>
                            </a>
                        </li>

                        <li>
                            <a href="#courses">
                                <FaChevronRight />
                                <span>Training Courses</span>
                            </a>
                        </li>

                        <li>
                            <a href="#leadership">
                                <FaChevronRight />
                                <span>Leadership Training</span>
                            </a>
                        </li>

                        <li>
                            <a href="#contact">
                                <FaChevronRight />
                                <span>Contact Us</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="cayep-footer-column">
                    <div className="cayep-footer-title">
                        <span className="cayep-footer-title-icon">
                            <FaBookOpen />
                        </span>

                        <h3>
                            Learning
                        </h3>
                    </div>

                    <ul>
                        <li>
                            <a href="#leader-mindset">
                                <FaChevronRight />
                                <span>Leader Mindset</span>
                            </a>
                        </li>

                        <li>
                            <a href="#career-development">
                                <FaChevronRight />
                                <span>Career Development</span>
                            </a>
                        </li>

                        <li>
                            <a href="#entrepreneurship">
                                <FaChevronRight />
                                <span>Entrepreneurship</span>
                            </a>
                        </li>

                        <li>
                            <a href="#business-management">
                                <FaChevronRight />
                                <span>Business Management</span>
                            </a>
                        </li>

                        <li>
                            <a href="#hr-management">
                                <FaChevronRight />
                                <span>HR Management</span>
                            </a>
                        </li>

                        <li>
                            <a href="#public-speaking">
                                <FaChevronRight />
                                <span>Public Speaking</span>
                            </a>
                        </li>

                        <li>
                            <a href="#strategic-planning">
                                <FaChevronRight />
                                <span>Strategic Planning</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="cayep-footer-contact-section">
                    <div className="cayep-footer-title">
                        <span className="cayep-footer-title-icon">
                            <FaMapMarkerAlt />
                        </span>

                        <h3>
                            Contact CAYEP
                        </h3>
                    </div>

                    <div className="cayep-footer-contact-grid">
                        <div className="cayep-footer-contact-card">
                            <div className="cayep-footer-contact-icon">
                                <FaMapMarkerAlt />
                            </div>

                            <div>
                                <span>
                                    Location
                                </span>

                                <p>
                                  Zayzay Community Monrovia, Liberia
                                </p>
                            </div>
                        </div>

                        <div className="cayep-footer-contact-card">
                            <div className="cayep-footer-contact-icon">
                                <FaPhoneAlt />
                            </div>

                            <div>
                                <span>
                                    Phone
                                </span>

                                <p>
                                    +231 778 216 866
                                </p>
                            </div>
                        </div>

                        <div className="cayep-footer-contact-card">
                            <div className="cayep-footer-contact-icon">
                                <FaEnvelope />
                            </div>

                            <div>
                                <span>
                                    Email
                                </span>

                                <p>
                                    info@cayep.com
                                </p>
                            </div>
                        </div>

                        <div className="cayep-footer-contact-card">
                            <div className="cayep-footer-contact-icon">
                                <FaClock />
                            </div>

                            <div>
                                <span>
                                    Learning Hours
                                </span>

                                <p>
                                    Mon - Fri: 8:00 AM - 5:00 PM
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="cayep-footer-connect">
                <div className="cayep-footer-connect-content">
                    <div className="cayep-footer-connect-icon">
                        <FaBullseye />
                    </div>

                    <div>
                        <h4>
                            Stay Connected With CAYEP
                        </h4>

                        <p>
                            Receive leadership insights, learning updates,
                            and training opportunities.
                        </p>
                    </div>
                </div>

                <div className="cayep-footer-newsletter">
                    <input
                        type="email"
                        placeholder="Enter your email address"
                        aria-label="Email address"
                    />

                    <button
                        type="button"
                        aria-label="Subscribe to newsletter"
                    >
                        Subscribe
                        <FaPaperPlane />
                    </button>
                </div>
            </div>

            <div className="cayep-footer-motto">
                <span></span>

                <p>
                    Learn With Purpose. Grow With Confidence. Lead With Impact.
                </p>

                <span></span>
            </div>

            <div className="cayep-footer-bottom">
                <div className="cayep-footer-bottom-inner">
                    <p>
                        © {currentYear}{" "}
                        <strong>CAYEP Leadership Training</strong>.
                        All Rights Reserved.
                    </p>

                    <div className="cayep-footer-bottom-links">
                        <a href="#privacy">
                            Privacy Policy
                        </a>

                        <span>|</span>

                        <a href="#terms">
                            Terms & Conditions
                        </a>

                        <span>|</span>

                        <a href="#contact">
                            Contact Support
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}